// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell {
  height: 1.5em;
  overflow: hidden;
}
.cell.value {
  text-align: center;
  border-bottom: 1px solid black;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/worksheet/job-worksheet-header.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;AACF;AACE;EACE,kBAAA;EACA,8BAAA;AACJ","sourcesContent":[".cell {\n  height: 1.5em;\n  overflow: hidden;\n\n  &.value {\n    text-align: center;\n    border-bottom: 1px solid black;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
